import React from 'react';
import {Loading} from "../components";
import {usePrivateRoute} from "./usePrivateRoute";
import {Redirect} from "react-router-dom";
import {AppRoutes} from "application/index";
import {connect} from "react-redux";
import {emptyFn} from "presentation/common/helpers/utils";

const PrivateRoute = (props) => {
  const {
    layout: Layout,
    component: Component,
    ...others
  } = props;

  const {isLoading, enableGuestUser} = usePrivateRoute(others);

  return isLoading
    ? <Loading/>
    : (
      props.isAuthenticated || enableGuestUser
        ?
        <Layout {...others}>
          <Component {...others}/>
        </Layout>
        :
        <Redirect to={AppRoutes.signIn}/>
    );
};

const mapState = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userInfo: state.auth.user,
})

const mapDispatch = (dispatch) => ({
  updateAuthStateAction: dispatch.auth.updateAuthStateAction,
  invalidateUserAction: dispatch.auth.invalidateUserAction,
  onSignOutAction: dispatch.auth.onSignOutAction,
})

PrivateRoute.defaultProps = {
  isAuthenticated: false,
  updateAuthStateAction: emptyFn,
  invalidateUserAction: emptyFn,
  onSignOutAction: emptyFn,
}

export default connect(mapState, mapDispatch)(PrivateRoute);
